/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { isDateTimeWithTimezoneEqualOrAfter } from '@irian-ro/date-utils';

export const arePickupAndDeliveryTimeWindowsValid = (shipment: any) => {
  const pickupTimeWindowStart = shipment?.pickup?.timeWindowDto?.timeWindowStart;
  const deliveryTimeWindowStart = shipment?.delivery?.timeWindowDto?.timeWindowStart;

  const pickupTimeWindowEnd = shipment?.pickup?.timeWindowDto?.timeWindowEnd;
  const deliveryTimeWindowEnd = shipment?.delivery?.timeWindowDto?.timeWindowEnd;

  if (!pickupTimeWindowStart) {
    return { pickupTimeWindowStartInvalid: true };
  }

  if (!deliveryTimeWindowStart) {
    return { deliveryTimeWindowStart: true };
  }

  if (!pickupTimeWindowEnd) {
    return { pickupTimeWindowEndInvalid: true };
  }

  if (!deliveryTimeWindowEnd) {
    return { deliveryTimeWindowEndInvalid: true };
  }

  const isPickupStartAfterDeliveryStart = isDateTimeWithTimezoneEqualOrAfter(
    pickupTimeWindowStart,
    deliveryTimeWindowStart
  );
  if (isPickupStartAfterDeliveryStart) {
    return isPickupStartAfterDeliveryStart;
  }

  const isPickupEndAfterDeliveryEnd = isDateTimeWithTimezoneEqualOrAfter(pickupTimeWindowEnd, deliveryTimeWindowEnd);
  if (isPickupEndAfterDeliveryEnd) {
    return isPickupEndAfterDeliveryEnd;
  }

  return null;
};
